import React, { useEffect, useState } from "react"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import * as wjcGrid from "@grapecity/wijmo.grid"
import { T勤怠リスト } from "./ZyomuinSyukkinbo"
import { e労務警告区分 } from "./zyomuinSyukkinboUtil"
import { Table } from "react-bootstrap"
import dayjs from "dayjs"
import { TKyuzituListGetRes } from "../../../service/master/kyuzitu/TKyuzitu"
import KyuzituService from "../../../service/master/kyuzitu/kyuzituService"
import { e休日区分 } from "../../../constant/enum/master"

const RoumuKeikokuModal: React.FC<
  TModalTypes & {
    選択行: wjcGrid.Row | null | undefined
    年月: string | undefined
  }
> = (props) => {
  const [休日リスト, set休日リスト] = useState<TKyuzituListGetRes[]>([])

  const 選択行Data = props.選択行?.dataItem as T勤怠リスト & {
    労務警告List?: string[]
  }

  const 稼働日 = dayjs(選択行Data?.勤務日)

  const 休日フラグ =
    休日リスト?.find(
      (i) =>
        選択行Data != null &&
        dayjs(稼働日).format("YYYYMMDD") ===
          dayjs(i.休日日付).format("YYYYMMDD")
    ) != null ||
    (選択行Data != null && dayjs(稼働日).day() === 0)

  useEffect(() => {
    Promise.all([
      new KyuzituService().getList({
        検索年: props.年月,
      }),
    ]).then(([休日Res]) => {
      set休日リスト([
        ...休日Res.data.filter(
          (d) =>
            d.休日区分コード === e休日区分.祝日 ||
            d.休日区分コード === e休日区分.会社休日
        ),
      ])
    })
  }, [props.年月])

  return (
    <ModalOuter
      isShow={props.isShow}
      setIsShow={props.setIsShow}
      title={props.title}
      dialogClassName="w-40rem">
      {選択行Data?.勤務日 && (
        <h3 className={休日フラグ ? "text-danger" : ""}>
          {稼働日?.format("YYYY年M月D日(dd)")}
        </h3>
      )}
      <Table bordered>
        <tbody>
          {選択行Data?.労務警告List?.includes(
            e労務警告区分.連続走行時間4時間以上
          ) && (
            <tr>
              <th className="text-center align-middle bg-red">40</th>
              <td>連続走行時間が４時間以上です。</td>
            </tr>
          )}
          {選択行Data?.労務警告List?.includes(
            e労務警告区分.拘束時間14時間超過
          ) && (
            <tr>
              <th className="text-center align-middle bg-red">31</th>
              <td>拘束時間が１４時間を超過しています。</td>
            </tr>
          )}

          {選択行Data?.労務警告List?.includes(e労務警告区分.休息3時間未満) && (
            <tr>
              <th className="text-center align-middle bg-red">21</th>
              <td>終業点呼から始業点呼まで３時間未満です。</td>
            </tr>
          )}
          {選択行Data?.労務警告List?.includes(
            e労務警告区分.電話点呼時中間点呼未存在
          ) && (
            <tr>
              <th className="text-center align-middle bg-red">20</th>
              <td>
                始業点呼・終業点呼が電話で行われていますが中間点呼が存在しません。
              </td>
            </tr>
          )}
          {選択行Data?.労務警告List?.includes(
            e労務警告区分.出勤打刻未存在かつデジタコ出庫存在
          ) && (
            <tr>
              <th className="w-3rem text-center align-middle bg-red">10</th>
              <td>
                始業時刻のデータが存在しますが出勤打刻が入力されていません
              </td>
            </tr>
          )}
          {選択行Data?.労務警告List?.includes(
            e労務警告区分.拘束時間13時間超過
          ) && (
            <tr>
              <th className="text-center align-middle bg-yellow">30</th>
              <td>拘束時間が１３時間１分以上です。</td>
            </tr>
          )}
          {選択行Data?.労務警告List?.includes(
            e労務警告区分.出勤打刻存在かつ退勤打刻未存在
          ) && (
            <tr>
              <th className="text-center align-middle bg-yellow">11</th>
              <td>当日に終業していますが、退勤打刻が入力されていません。</td>
            </tr>
          )}
        </tbody>
      </Table>
    </ModalOuter>
  )
}

export default RoumuKeikokuModal
